import React from "react";
import Bracket from "../../components/structure/Bracket";
import { groupBy } from "../../util/GroupBy";

class BracketContainer extends React.Component {
  state = {
    matches: [],
  };

  UNSAFE_componentWillMount() {
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    if (!this.props.resultsPage) {
      this.unsubscribeMatches = tournamentRef
        .collection("matches")
        .where("bracket", "==", this.props.bracket.id)
        .onSnapshot((querySnapshot) => {
          var matches = [];
          querySnapshot.forEach(function (doc) {
            let match = doc.data();
            match["id"] = doc.id;
            matches.push(match);
          });
          this.setState({
            matches: matches,
          });
        });
    }
  }

  componentWillUnmount = () => {
    if (this.unsubscribeMatches) {
      this.unsubscribeMatches();
    }
  };

  pouleRefs = [];
  handleDelete = () => {
    const db = window.firebase.firestore();

    let deleteBatch = db.batch();
    let allDeleteBatches = [];

    this.pouleRefs.reverse().forEach((ref) => {
      let batches = ref.deletePoule();
      allDeleteBatches = allDeleteBatches.concat(batches);
    });

    deleteBatch.delete(
      db
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .collection("brackets")
        .doc(this.props.bracket.id),
    );
    allDeleteBatches.unshift(deleteBatch);

    const affectedPairs = new Set();
    this.state.matches.forEach((match) => {
      if (match.field != null) {
        affectedPairs.add(`${match.field}__${match.day || "0"}`);
      }
    });

    Promise.all(allDeleteBatches.map((b) => b.commit())).then(() => {
      let cacheBatch = db.batch();
      let numInCacheBatch = 0;
      const allCacheBatches = [cacheBatch];

      affectedPairs.forEach((pair) => {
        const [fieldId, dayId] = pair.split("__");
        if (numInCacheBatch >= 499) {
          cacheBatch = db.batch();
          allCacheBatches.push(cacheBatch);
          numInCacheBatch = 0;
        }
        cacheBatch.set(db.collection("cacheUpdates").doc(), {
          tournamentId: this.props.tournament[".key"],
          fieldId,
          dayId,
          status: "pending",
          timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
        });
        numInCacheBatch++;
      });

      if (this.props.tournament.ia) {
        if (numInCacheBatch >= 499) {
          cacheBatch = db.batch();
          allCacheBatches.push(cacheBatch);
        }
        cacheBatch.set(db.collection("cacheUpdatesApp").doc(), {
          tournamentId: this.props.tournament[".key"],
          status: "pending",
          timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
        });
      }

      // Wait to make sure all matches are deleted before updating the cache
      // Sometimes this takes a while and the cache will not be updated, since the cache update
      // will result in an error when it tries to access the deleted matches
      setTimeout(() => {
        Promise.all(allCacheBatches.map((b) => b.commit()));
      }, 1000);
    });
  };

  toggleLosersFinal = () => {
    const db = window.firebase.firestore();

    let batch = db.batch();

    batch.update(
      db
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .collection("brackets")
        .doc(this.props.bracket.id),
      { showLosersFinal: !this.props.bracket.showLosersFinal },
    );

    if (this.props.tournament.ia) {
      batch.set(db.collection("cacheUpdatesApp").doc(), {
        tournamentId: this.props.tournament[".key"],
        status: "pending",
        timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
      });
    }

    if (this.props.bracket.showLosersFinal) {
      let poule = this.props.poules.find((p) => p.losersFinal === true);
      if (poule) {
        db.collection("tournaments")
          .doc(this.props.tournament[".key"])
          .collection("matches")
          .where("poule", "==", poule.id)
          .get()
          .then((snapshot) => {
            snapshot.forEach((m) => {
              let match = m.data();

              if (match.field) {
                batch.set(db.collection("cacheUpdates").doc(), {
                  tournamentId: this.props.tournament[".key"],
                  fieldId: match.field,
                  dayId: match.day,
                  status: "pending",
                  timestamp:
                    window.firebase.firestore.FieldValue.serverTimestamp(),
                });
              }
              batch.update(
                db
                  .collection("tournaments")
                  .doc(this.props.tournament[".key"])
                  .collection("matches")
                  .doc(m.id),
                { field: null, day: "0" },
              );
            });
            batch.commit();
          });
      } else {
        batch.commit();
      }
    } else {
      batch.commit();
    }
  };

  render() {
    const poulesPerRound = groupBy(this.props.poules, "bracketRound");
    return (
      <Bracket
        handleDelete={this.handleDelete}
        onRef={(ref) => this.pouleRefs.push(ref)}
        {...this.props}
        toggleLosersFinal={this.toggleLosersFinal}
        poulesPerRound={poulesPerRound}
      />
    );
  }
}

export default BracketContainer;
